<template>
  <div class="content text-center">


        <el-row>
           <el-col :span="2" class="text-left" style="width:100%; background: rgb(240, 240, 240);">
            <div style="top:29px;left:10px;z-index: 20;" >
              <el-badge style="top:3px;width:50px;" v-model="count_table" class="item"></el-badge>
              <el-button style="left:30px;height:35px;width:120px;line-height:4px;background-color: rgb(108, 117, 125) !important; color: white !important;"  @click="show3 = !show3" align="right" >Filtrer(s)</el-button>
              <el-input style="top:-1px;left:20px;z-index: 20;width:170px"
                v-model="search"
                size="mini"
                placeholder="Rechercher"/>
            </div>
           </el-col>
        </el-row>

        <el-collapse-transition>
          <div v-show="show3">
              <el-card class="box-card BoxDetailFiltre3">
                    <el-form ref="form" label-width="120px" size="mini">
           
                               <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                           Type client
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                               <el-select v-model="dialogActionValues.LIB_TYPE" size='mini' style="margin-left:0px;margin-top:-5px;width:300px" placeholder="Veuillez sélectionner un prospect" class="selectColDroite2">
                                                  <el-option align="left"
                                                    v-for="item in dialogActionFiltre.LIB_TYPE "
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                  </el-option>
                                              </el-select> 
                                          </el-col>
                              </el-row>
                              
                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px ;margin-top:5px">
                                              <span>
                                               Groupe 
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                            <el-select v-model="dialogActionValues.GROUPE" size='mini' style="margin-left:0px;margin-top:-5px;width:300px" 
                                                  placeholder="Veuillez sélectionner une ville" class="selectColDroite2" id='selectClient'  name='groupe' filterable>
                                                  <el-option align="left"
                                                    v-for="item in dialogActionFiltre.GROUPE "
                                                    :key="item.GROUPE"
                                                    :label="item.GROUPE"
                                                    :value="item.GROUPE"
                                                    >
                                                  </el-option>
                                         </el-select>

                                          </el-col>
                              </el-row>


                               <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px ;margin-top:5px">
                                              <span>
                                               Ville 
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                            <el-select v-model="dialogActionValues.VILLE" size='mini' style="margin-left:0px;margin-top:-5px;width:300px;" 
                                                  placeholder="Veuillez sélectionner une ville" class="selectColDroite2" id='selectClient'  name='ville' filterable>
                                                  <el-option align="left"
                                                    v-for="item in dialogActionFiltre.VILLE "
                                                    :key="item.VILLE"
                                                    :label="item.VILLE"
                                                    :value="item.VILLE"
                                                    >
                                                  </el-option>
                                         </el-select>

                                          </el-col>
                              </el-row>

                             
                               <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px ;margin-top:5px">
                                              <span>
                                               Secteur 
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model="dialogActionValues.SECTEUR_COMMERCIAL" size='mini' style="margin-left:0px;margin-top:-5px;width:300px" 
                                                  placeholder="Veuillez sélectionner un client" class="selectColDroite2" id='selectClient'  name='client' filterable>
                                                  <el-option align="left"
                                                    v-for="item in dialogActionFiltre.SECTEUR_COMMERCIAL "
                                                    :key="item.SECTEUR_COMMERCIAL"
                                                    :label="item.SECTEUR_COMMERCIAL"
                                                    :value="item.SECTEUR_COMMERCIAL"
                                                    >
                                                  </el-option>
                                                 
                                              </el-select>
                                          </el-col>
                              </el-row>

                               <el-row class="ligneActFiltre">
                                  <el-col class="ColonneGauche" :span="3" style="margin-left:200px ;margin-top:40px">
                                  <el-button
                                      type="primary"
                                      size="small "
                                      id="delete_filtre"
                                      icon="el-icon-check"
                                      @click="handle_delete_filtre">Effacer les filtres
                                </el-button>
                                 </el-col>
                              </el-row>
                    </el-form>


      

              </el-card>
           </div>
       </el-collapse-transition>

                               
     
      <div class="table-container">
        

        <el-table

           :data="tableDataComputedClient"  :cell-class-name="handleColorProspect"
           
         style="width: 100%;"
        height=95%
         stripe
         class="tableCenter"
         
         empty-text="Aucun résultat !">

        
         <!--<el-table-column
           prop="LIB_TYPE"
           label="Type"
           :filters="[{text: 'Client', value: 'Client'}, {text: 'Prospect', value: 'Prospect'}]"
           :filter-method="filterHandler"
           width="100"
           sortable>
         </el-table-column>-->

          <el-table-column
            prop="VENDEUR"
            label="Commercial"
              width="120"
            sortable>
          </el-table-column>

          

          <el-table-column
            prop="NOM_CLI"
            label="Nom client"
            width="260"
            text-align= "center"
            sortable>
          </el-table-column>

          <el-table-column
            prop="ADRESSE_COMPLETE_CLIENT"
            label="Ville"
             width="180"
            sortable>
          </el-table-column>

          <el-table-column
            prop="PAYS"
            label="Pays"
            width="110"
            sortable>
          </el-table-column>
          
          <el-table-column
            prop="SECTEUR_COMMERCIAL"
            label="Secteur"
            width="100"
            sortable>
          </el-table-column>

          <el-table-column
            prop="FREQUENCE"
            label="Fréquence"
            width="112"
            text-align= "center"
            sortable>
          </el-table-column>

          <el-table-column
            prop="derniere"
            label="Derniere Action"
            width="142"
            text-align= "center"
            sortable>
          </el-table-column>

          <el-table-column
            prop="prochaine"
            label="Prochaine Action"
            width="150"
            text-align= "center"
            sortable>
          </el-table-column>

          <el-table-column
            prop="NB_ACTION"
            label="Nbr Actions"
            width="120"
            text-align= "center"
            sortable>
          </el-table-column>

          <el-table-column
            prop="MARCHE"
            label="Marché"
              width="140"
            sortable>
          </el-table-column>

          <el-table-column
            prop="GROUPE"
            label="Groupe"
              width="120"
            sortable>
          </el-table-column>

          <el-table-column
            prop="ACTIVITE"
            label="Activité"
            width="130"
            sortable>
          </el-table-column>




           <!--
             <el-table-column
            prop="BUDGET"
            label="Montant Prévu"
               width="150"
            sortable>
          </el-table-column>--> 
             <!-- <el-table-column
            prop="PU_CA"
            label="Prix uititaire"
               width="150"
            sortable>
          </el-table-column> -->
          <!-- <el-table-column
            prop="CA"
            label="Montant Realiser"
               width="150"
            sortable>
          </el-table-column> 

           <el-table-column
            prop="ECART"
            label="Ecart valeur"
               width="120"
              
            sortable>
          </el-table-column>
           <el-table-column
            prop="ECARTS"
            label="Ecart %"
               width="100"
            sortable>
          </el-table-column>-->
          
        </el-table>
        <div class="block">
    
    <el-pagination
      @size-change="handleSizeChangePagination"
      @current-change="handleCurrentChangePagination"
      :page-size="table_size"
      layout="sizes,prev, pager, next, jumper"
      :total="count_table">
    </el-pagination>
  </div>
      </div>
    
  </div>
</template>
<script>
   import $ from 'jquery'
  import axios from 'axios';

  import {BACKEND_URL} from './GLOBALS'

    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
 
 import Vue from 'vue'


function extractColumn(arr, column) {
  let temps = []
  let result = []
  arr.forEach(element => {
    if(!temps.includes(element[column])) {
      temps.push(element[column])
      let o = {}
      o[column] = element[column]
      if(element[column] != null)
      result.push(o)
    }
  });
  return result.sort(function(a, b) {
    const nameA = a[column].toUpperCase().trim(); // ignore upper and lowercase
    const nameB = b[column].toUpperCase().trim(); // ignore upper and lowercase
    if (nameA > nameB)
      return 1;
    if (nameA < nameB)
      return -1;
    return 0;
  });
}

const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
}) 
  
    export default {
      name:'Suivi_Clients',
    data() {
      return {
        table_index:0,
        table_size:100,
        count_table :0,
         showTableRefresh:true,
         show3: false,
         filtrage:'',
         actives:true,
        tableData: '',
        search :'',
        Ecart:'',
        resultSearchClient:'',
        detail_freq:'',
        DTE_REAL:'',
        FREQUENCE:'',
        
        dialogActionFiltre :{
    
        LIB_TYPE:[{text: 'Client', value: 'Client'}, {text: 'Prospect', value: 'Prospect'}],
        SECTEUR_COMMERCIAL:'',
        VILLE:'',
        GROUPE:'',
      },
        dialogActionValues :{
        LIB_TYPE:'',
        SECTEUR_COMMERCIAL:'',
        VILLE:'',
       // ADR3_CMDE:'',
        GROUPE:'',
        },
       listeClients:{}
      }
    },
    computed: {

                  
                  // a computed getter
                  tableDataComputedClient: function () {
                      // `this` points to the vm instance
                      
                           var resultSearchClient= this.tableData.map(element=>{
                                    return {
                                    
                                      //Action: element.Action== null?'': element.Action,
                                     // derniere: element['Action'][0]==null?'': element['Action'][0].DTE_REAL, 
                                      derniere:element.DTE_VISITE== null?'' :element.DTE_VISITE.substring(0, 10) ,
                                      LIB_TYPE :element.LIB_TYPE == null?'' :element.LIB_TYPE  ,
                                      NOM_CLI :element.NOM_CLI == null?'' :element.NOM_CLI  ,
                                      CDE_CLI:element.CDE_CLI == null?'':element.CDE_CLI,
                                      FREQUENCE:element.FREQUENCE= null? 'ko':element.FREQUENCE,
                                      ADRESSE_COMPLETE_CLIENT:element.VILLE == null?'' : element.CP_CMDE == null?element.VILLE :element.CP_CMDE+' '+element.VILLE,
                                      VILLE:element.VILLE == null?'':element.VILLE,
                                      PAYS:element.PAYS_CMDE == null?'':element.PAYS_CMDE,
                                      SECTEUR_COMMERCIAL:element.SECTEUR_COMMERCIAL==null?'':element.SECTEUR_COMMERCIAL,
                                      BUDGET:element.BUDGET==null?'':element.BUDGET,
                                      MARCHE:element.MARCHE==null?'':element.MARCHE,
                                      VENDEUR:element.VENDEUR==null?'':element.VENDEUR,
                                      ACTIVITE:element.ACTIVITE==null?'':element.ACTIVITE,
                                      GROUPE:element.GROUPE==null?'':element.GROUPE,
                                      NB_ACTION:element.NB_ACTION==null?'':element.NB_ACTION,
                                      CA:element.CA==null?'':element.CA,
                                      ECART:this.ecart(element.CA,element.BUDGET),
                                      prochaine:element.DTE_PRO== null?'' :element.DTE_PRO.substring(0, 10) ,
                                    //  prochaine:this.dateNextC(element['Action'][0]==null?'': element['Action'][0].DTE_REAL,element.FREQUENCE),
                                      ECARTS: this.ecartPourcentage(element.CA,element.BUDGET)
              
                                      // BUDGET:this.budget(element.BUDGET),
                                      // BUDGET:element.BUDGET==null?'':Math.round(element.BUDGET),
                                      // CA:element.CA==null?'':Math.round(element.CA),
                                      //ECART:Math.round((element.CA - element.BUDGET)*100) /100,
                                      //  ECARTS:element.BUDGET==null?100: Math.round((((element.CA - element.BUDGET)* 100)/element.BUDGET)* 100) / 100

                                    }
                          })
                           
                                

                   resultSearchClient= resultSearchClient.filter(data => !this.search ||
                       // data.derniere.toLowerCase().includes(this.search.toLowerCase()) ||
                       // data.prochaine.toLowerCase().includes(this.search.toLowerCase()) ||
                        data.LIB_TYPE.toLowerCase().includes(this.search.toLowerCase()) ||
                        data.NOM_CLI.toLowerCase().includes(this.search.toLowerCase()) ||
                        // data.FREQUENCE.toLowerCase().includes(this.search.toLowerCase()) ||
                        data.CDE_CLI.toLowerCase().includes(this.search.toLowerCase()) ||
                        data.SECTEUR_COMMERCIAL.toLowerCase().includes(this.search.toLowerCase()) ||
                        data.ADRESSE_COMPLETE_CLIENT.toLowerCase().includes(this.search.toLowerCase())||
                        data.VILLE.toLowerCase().includes(this.search.toLowerCase()) ||
                        data.MARCHE.toLowerCase().includes(this.search.toLowerCase()) || 
                        data.VENDEUR.toLowerCase().includes(this.search.toLowerCase())
                        // on peut pas recherche selon l'ecart valeur et l' ecart%
                        //data.ECART.toLowerCase().includes(this.search.toLowerCase())||
                        // data.ECARTS.toLowerCase().includes(this.search.toLowerCase())
                       )
                         for( name in this.dialogActionValues){
                              if (typeof name == "string"){
                                if (this.dialogActionValues[name] != '' ){
                                  
                                  resultSearchClient= resultSearchClient.filter(data => data[name].toLowerCase().includes(this.dialogActionValues[name].toLowerCase()))
                                }
                                
                              }
                            }

                            this.dialogActionFiltre.SECTEUR_COMMERCIAL=extractColumn(resultSearchClient, "SECTEUR_COMMERCIAL")
                            this.dialogActionFiltre.VILLE=extractColumn(resultSearchClient, "VILLE")
                            this.dialogActionFiltre.GROUPE=extractColumn(resultSearchClient, "GROUPE")

                            this.count_table=resultSearchClient.length;
                            return  resultSearchClient.slice(this.table_index*this.table_size, (this.table_index + 1)*this.table_size);

                              
                    },


               
                       
                     
     },
     mounted (){
      let btn_next  = document.getElementsByClassName("btn-next")[0];
      btn_next.style = "margin-top:7px";
      let btn_prev  = document.getElementsByClassName("btn-prev")[0];
      btn_prev.style = "margin-top:7px";
     },
    methods:{
      handleSizeChangePagination(val){
        this.table_size=val;
      },
        handleCurrentChangePagination(val){
            this.table_index=val;
        },
          dateNextC(DTE_REAL,FREQUENCE){

                     

                if (DTE_REAL !='' && FREQUENCE !=''){

                      if (FREQUENCE == 'SEMESTRE'){
                             
                               return  moment(DTE_REAL,'DD-MM-yyyy HH:mm ').add(6, 'months').format('DD-MM-yyyy HH:mm');
                            }
                                  else if(FREQUENCE=='TRIMESTRE'){
                                      return moment(DTE_REAL,'DD-MM-yyyy HH:mm').add(3, 'months').format('DD-MM-yyyy HH:mm');
                                  } 
                              
                                  else if(FREQUENCE=='MOIS'){
                                  return  moment(DTE_REAL,'DD-MM-yyyy HH:mm').add(1, 'months').format('DD-MM-yyyy HH:mm');
                            }
                 }
           },

      filterHandler(value, row){
        return row.LIB_TYPE === value;
     
      },
      

        handle_delete_filtre () {

          this.dialogActionValues.LIB_TYPE = ''
          this.dialogActionValues.VILLE = ''
          this.dialogActionValues.GROUPE = ''
           this.dialogActionValues.SECTEUR_COMMERCIAL = ''
      },

       handleFrequence(num_act){
          
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'handleFrequence': 1,
                    'numAct':this.numAct,
                    'detail_freq':this.detail_freq 
                },
                dataType: "html",
                success: function(data) {
                   
                }
            });

        },

      handle_valider_filtre(){
	    	},

      
        ecart(CA,BUDGET){
             var self =this ;
         var ecartValeur=[]

         if((CA!=null && CA!='' && CA!=undefined)&&
                (BUDGET!=''&& BUDGET!=null && BUDGET!=undefined))
                {
                  const CARound = Math.round(CA)
                          

                const BudgetRound = Math.round(BUDGET)
                        

                      const diff= CARound-BudgetRound
                              
                 return diff
                 }
                 else if(BUDGET==null){
                   return CA
                 }
                 else if( CA==null){
                   return -BUDGET
                 }
                 
        },
        
    handleColorProspect({row, column, rowIndex, columnIndex}){
      
      if (row.LIB_TYPE === 'Prospect' && column.property==='NOM_CLI')  {
          return 'blue-cell' 
      }
      return '';
    },
         ecartPourcentage(CA,BUDGET){

              if((CA!=null && CA!='' && CA!=undefined)&&
                (BUDGET!=''&& BUDGET!=null && BUDGET!=undefined))
                {
                  const CARound = Math.round(CA)
                          
                  const BudgetRound = Math.round(BUDGET)
                        

                  const diff= CARound-BudgetRound
                            
                            const ecartP=Math.round(((diff * 100)/BUDGET)* 100)/100
                          
                    return ecartP
                }   
                 else if(CA == null && BUDGET!=null){
                   return -100
                 }
                 else if(BUDGET==null && CA ==null)
                 {   return null
                 }
                 else return 100

              


        }
                   
       
    },
     created() {
        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
       var self= this
        var request = $.ajax({
            url: BACKEND_URL+"controller/Suivi_Clients.php",
            async: false,
            type: "POST",
            data: {
            },
            dataType: "html",
            success: function(data) {            
                 var dataParsed = JSON.parse(data)

                 if (self.$store.getters.vendeur != null)
                  self.tableData=dataParsed.listeClients.filter(data=>data.VENDEUR2==self.$store.getters.vendeur || data.VENDEUR==self.$store.getters.vendeur )
                 else
                  self.tableData=dataParsed.listeClients             
                
                  self.dialogActionFiltre.SECTEUR_COMMERCIAL=extractColumn(self.tableData, "SECTEUR_COMMERCIAL")
                  self.dialogActionFiltre.VILLE=extractColumn(self.tableData, "VILLE")
                  self.dialogActionFiltre.GROUPE=extractColumn(self.tableData, "GROUPE")
                  self.adr3_cmde=dataParsed.listeClients
                 // self.FREQUENCE=dataParsed.listeClients
                  self.derniere= dataParsed.listeClients.map(element=>(element.Action ==null || element.Action[0]==null)?'': element.Action[0].DTE_REAL)
                
            }
          
        })
          
      }
    }
  
</script>
<style>
</style>